import { useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import Logo from '../../../../../assets/images/brand/only-logo.png';
import slugify from '../../../../../core/commom/slugify';
import {
  DropDownList,
  IDropDownItems,
} from '../../../../../core/components/molecules/DropDownList';
import { Breadcrumbs } from '../../../../../core/components/organism/Breadcrumbs';
import { IWeekSchedule } from '../../../model/weekSchedule';
import { useDailyScheduleContentStore } from '../../../stores/useDailyScheduleContent';
import { DisciplineScheduleSlot } from '../DisciplineScheduleSlot';
import './index.css';

interface ITemplateHeader {
  weekSchedule: IWeekSchedule;
  onDaySelect?: (day: IDropDownItems) => void;
  onDisciplineSelect?: (discipline: string) => void;
}

export const TemplateHeader = ({
  weekSchedule,
  onDaySelect,
  onDisciplineSelect,
}: ITemplateHeader) => {
  const { scheduleId } = useParams();
  const { setSelectedContent } = useDailyScheduleContentStore();

  const {
    selectedDay,
    setSelectedDay,
    selectedDiscipline,
    setSelectedDiscipline,
  } = useDailyScheduleContentStore();

  const buildBreadcrumb = () => {
    return [
      { label: 'Painel', href: `/plano-adaptativo/${scheduleId}/hub` },
      { label: `Semana ${weekSchedule?.semana}`, href: '#' },
    ];
  };

  const disciplinesList = useMemo(() => {
    if (!selectedDay) return [];

    const day = slugify(selectedDay.title);
    const daySchedule =
      weekSchedule?.dias?.[day as keyof typeof weekSchedule.dias];

    return daySchedule || [];
  }, [weekSchedule, selectedDay]);

  const handleSelectDay = (day: IDropDownItems) => {
    if (onDaySelect) {
      onDaySelect(day);
    } else {
      setSelectedDay(day);
      setSelectedContent(null);
    }
  };

  const handleSelectDiscipline = (discipline: string) => {
    if (onDisciplineSelect) {
      onDisciplineSelect(discipline);
    } else {
      setSelectedDiscipline(discipline);
      setSelectedContent(null);
    }
  };

  const formatDayTitle = (day: IDropDownItems) => {
    day.title = day.title.charAt(0).toUpperCase() + day.title.slice(1);

    return day;
  };

  return (
    <div className='hidden items-center gap-md rounded-[32px] bg-mono-color-white p-3 lg:flex '>
      <div className='h-full flex-row items-center justify-start gap-lg xs:hidden lg:flex lg:w-fit '>
        <Breadcrumbs items={buildBreadcrumb()} />
      </div>

      <div className='h-10 w-3 border-r-hairline border-mono-color-medium' />

      <DropDownList
        size='compact'
        items={weekSchedule?.days || []}
        onSelect={handleSelectDay}
        value={selectedDay ? formatDayTitle(selectedDay) : null}
      />

      <div
        id='disciplines-list-container'
        className='flex grow flex-row items-center gap-sm overflow-x-auto'
      >
        {disciplinesList.map((item) => (
          <DisciplineScheduleSlot
            title={item.title}
            disciplineSlug={item.nome}
            currentProgress={item.percentualConclusao}
            totalProgress={100}
            compact
            onClick={() => handleSelectDiscipline(item.nome)}
            key={item.nome}
            selected={selectedDiscipline === item.nome}
          />
        ))}
      </div>
    </div>
  );
};
